<!--
 * @Author: 向上的阳光李子
 * @Date: 2024-06-14 16:15:38
 * @LastEditTime: 2024-07-05 14:34:16
 * @Description: title
 * @FastButton: ctrl+win+i, ctrl+win+t
-->
<template>
  <LayoutPage> </LayoutPage>
</template>

<script>
import LayoutPage from "./layouts/layout-page.vue";
export default {
  name: "App",
  components: {
    LayoutPage,
  },
};
</script>

<style></style>
